import styled from 'styled-components';

const Card = styled.div`
    border: 2px solid #e6e6e6;
    border-radius: 8px;
    padding: 20px;
`;

export default Card;
